<template>
    <table class='table'>
        <thead class="thead-light">
            <tr>
                <th>{{ $t('translations.session')}}</th>
                <th>{{ $t('translations.min_book_ahead_time')}}</th>
                <th>{{ $t('translations.max_book_ahead_time')}}</th>
                <th>{{ $t('translations.appointments_interval')}}</th>
                <th v-if='edit'><button v-on:click.prevent='value.push({name: "", id: -value.length})' class="btn btn-primary btn-block btn-round btn-sm">{{ $t('translations.add')}}</button></th>
            </tr>
        </thead>
        <tbody>
            <template v-if='value && value.length'>
                <appointment-session-type v-for='(appointment, index) in value' 
                    v-model='value[index]' 
                    :key='index' 
                    @remove='value.splice(index, 1)'
                    :edit='edit' />
            </template>
            <template v-else>
                <tr>
                    <td :colspan='edit ? 4 : 3'>{{ $t('translations.no_session_types_found')}}</td>
                </tr>
            </template>
        </tbody>
    </table>
</template>

<script>

export default {
    name: 'appointment-session-type-table',
    props: {
        value: {

        },
        edit: {
            default: false
        }
    },
    data() {
        return {
            
        };
    },
    computed: {

    },
    watch: {

    },
    methods: {
        
    },
};
</script>